import { render, staticRenderFns } from "./Step01Recipient.vue?vue&type=template&id=d013a98a"
import script from "./Step01Recipient.vue?vue&type=script&lang=js"
export * from "./Step01Recipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports